import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSaveBookmark = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SaveBookmark</title>
    <path
      d="M25.143 28.403a.571.571 0 0 1-.919.454l-7.877-6.018a.572.572 0 0 0-.694 0l-7.878 6.018a.571.571 0 0 1-.918-.454V7.837a3.422 3.422 0 0 1 3.427-3.421h11.434a3.425 3.425 0 0 1 3.425 3.428v20.559Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSaveBookmark;
